import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { themeGet } from "sprout-ui-theme";
const StyledBox = styled(Box)`
  box-shadow: 0 3px 6px ${themeGet("colors.black.16")};

  em {
    font-style: normal;
    font-weight: ${themeGet("fontWeights.bold")};
  }

  ${({ $rotate  })=>$rotate && css`
      transform: rotate(1deg);
    `}

  ${({ $position  })=>$position === "fixed" && css`
      position: fixed;
      top: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: calc(100% - 32px);
      z-index: 4;
    `}
`;
const OnboardMessage = (props)=>{
    const { children , title , position , variant , rotate  } = props;
    const isWelcome = variant === "welcome";
    return /*#__PURE__*/ _jsxs(StyledBox, {
        width: "100%",
        $position: position,
        $rotate: rotate,
        bg: !isWelcome ? "yellow.100" : "blue.50",
        borderRadius: "12px",
        py: 10,
        px: [
            4,
            10,
            12
        ],
        maxWidth: "500px",
        children: [
            title && /*#__PURE__*/ _jsx(Text, {
                textAlign: "center",
                fontSize: isWelcome ? 3 : [
                    4,
                    5
                ],
                fontWeight: isWelcome ? undefined : "bold",
                mb: 4,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "p",
                textAlign: "center",
                fontSize: 3,
                lineHeight: 1.6,
                children: children
            })
        ]
    });
};
export default OnboardMessage;
